import React, {FC} from 'react'
import styled from 'styled-components'

import {countChars} from '@atomic.io/common/types/char-limits'

const Count = styled.span<{$over: boolean}>`
  pointer-events: none;
  font-size: 11px;
  line-height: 1;
  white-space: nowrap;
  color: ${p => (p.$over ? p.theme.colors.orange11 : p.theme.colors.grey10)};
`

// Only surface the counter once the author is getting close to the limit, to
// avoid cluttering every input with a count that's rarely relevant.
const SHOW_THRESHOLD = 0.75

// A compact character counter intended to sit inline, on the same row as its
// input (the host positions it). Hidden until the value reaches 75% of the
// limit, then turns orange once it reaches/exceeds the limit. Input components
// hard-block at the limit, so `count` should only exceed `maxLength` for
// pre-existing over-limit content the author is editing down.
export const InlineCharCount: FC<{
  value: string | undefined
  maxLength: number
  className?: string
  style?: React.CSSProperties
}> = ({value, maxLength, className, style}) => {
  const count = countChars(value)
  if (count < maxLength * SHOW_THRESHOLD) {
    return null
  }
  return (
    <Count className={className} $over={count >= maxLength} style={style}>
      {count}/{maxLength}
    </Count>
  )
}

// The counter sitting in-flow on the same row as the editor (used by the
// contentEditable editors and the action-flow Input). In-flow rather than
// overlaid so the input shrinks to make room instead of the value running
// under the counter.
export const InlineCharCountRow = styled(InlineCharCount)`
  flex-shrink: 0;
  align-self: center;
  padding: 0 12px;
`
